export const formatIDR = (amount) => {
  if (amount === null || amount === undefined) return 'Rp 0';
  
  const formatter = new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  });
  
  return formatter.format(amount);
};

export const formatIDRWithDecimals = (amount, decimals = 2) => {
  if (amount === null || amount === undefined) return 'Rp 0';
  
  const formatter = new Intl.NumberFormat('id-ID', {
    style: 'currency',
    currency: 'IDR',
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  });
  
  return formatter.format(amount);
};

export const formatCryptoIDR = (amount) => {
  if (amount === null || amount === undefined) return 'Rp 0';
  
  const formatted = new Intl.NumberFormat('id-ID', {
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(amount);
  
  return `Rp ${formatted}`;
};

export const parseIDR = (value) => {
  if (typeof value !== 'string') return value;
  
  return parseFloat(value.replace(/[Rp\s.]/g, '').replace(',', '.'));
};